import React from "react";
import PropTypes from "prop-types";

import ReactDatePicker from "react-datepicker";

import "./GridDatePicker.scss";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";

const GridDatePicker = ({
    name,
    label,
    selected,
    onChange,
    placeholder,
    onBlur,
    isDisable,
    popperPlacement = "bottom-start",
    portalTarget = document.body,
}) => {
    const handleButtonClick = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div className="date-picker">
            <ReactDatePicker
                name={name}
                placeholderText={placeholder}
                label={label}
                selected={selected}
                onChange={(e) => handleButtonClick(e)}
                onBlur={onBlur}
                autoComplete="off"
                disabled={isDisable}
                // Ensure popup follows the body flow
                popperPlacement={popperPlacement}
                portalId="datepicker-portal"
                renderPopperContainer={({ children }) => (
                    <div style={{ zIndex: 999 }}>{children}</div>
                )}
                popperModifiers={[
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: "viewport",
                        },
                    },
                ]}
                popperProps={{
                    strategy: "fixed",
                }}
                shouldCloseOnScroll={true}
            />
        </div>
    );
};

GridDatePicker.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    isDisable: PropTypes.bool,
    popperPlacement: PropTypes.string,
    portalTarget: PropTypes.instanceOf(Element),
};

export default GridDatePicker;
